export class PasswordChange {
    emailAddress: string;
    newPassword: string;
    
    constructor(values: object = {}) {
      Object.assign(this, values);
    }
  }
  